import * as React from 'react';
import { CONTACT_US_URL } from 'config/constants';
import GuestDetailsModal, { GuestAmendmentProvider } from 'components/GuestDetailsModal';
import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { ActionBar, ActionItem } from 'pages/BookingDetailsPage/ActionBar';
import useDetailsBooking from 'hooks/useDetailsBooking';
import { getChangeYourBookingLink } from 'lib/links';
import { SelfServiceAPI } from 'apis';
import { useDownloadInvoiceErrorModal } from '../Alerts/Modal/DownloadInvoiceError';
import { GA } from 'types';
import sendGAEvent from 'utils/sendGAEvent';
import useLocalModal from 'hooks/useLocalModal';

const ManageBookingActions: React.FC = () => {
  const {
    openModal,
    closeModal,
    modalProps: { isOpen },
  } = useLocalModal();
  const { booking } = useDetailsBooking();
  const openDownloadInvoiceErrorModal = useDownloadInvoiceErrorModal();
  const changeYourBookingUrl = getChangeYourBookingLink(booking);

  const {
    flags: { isCancelableInApp, isChangeInProgress, isFinalising },
  } = booking;

  return (
    <>
      <ActionBar label="Manage your booking">
        {!isFinalising && (
          <ActionItem
            key="update-guest-details-link"
            icon="contactPage"
            label="Update guest details"
            onClick={() => {
              openModal();
              tracking.updateGuestDetailsLinkSelected();
              sendGAEvent({
                type: GA.EventType.MENU_CLICK,
                itemText: GA.ItemText.UPDATE_GUEST_DETAILS,
              });
            }}
          />
        )}
        {changeYourBookingUrl && !isFinalising && (
          <ActionItem
            key="change-your-booking-link"
            icon="event"
            label="Change your booking"
            url={changeYourBookingUrl}
            external={false}
            onClick={() => {
              tracking.changeYourBookingLinkSelected();
              sendGAEvent({
                type: GA.EventType.MENU_CLICK,
                itemText: GA.ItemText.CHANGE_YOUR_BOOKING,
              });
            }}
          />
        )}
        {isCancelableInApp && !isFinalising && (
          <ActionItem
            key="cancel-your-booking-link"
            icon="cancel"
            label="Cancel your booking"
            url={`${booking.links.manage}/cancellation-quote`}
            external={false}
            onClick={() => {
              tracking.cancelYourBookingLinkSelected();
              sendGAEvent({
                type: GA.EventType.MENU_CLICK,
                itemText: GA.ItemText.CANCEL_YOUR_BOOKING,
              });
            }}
          />
        )}
        <ActionItem
          key="contact-us-link"
          icon="contactSupport"
          label="Contact us"
          url={CONTACT_US_URL}
          external={true}
          onClick={tracking.contactUsLinkSelected}
          target="_blank"
        />
        {!isChangeInProgress && (
          <ActionItem
            key="download-invoice-link"
            icon="getApp"
            label="Download invoice"
            onClick={async () => {
              tracking.downloadInvoiceLinkSelected('Manage your booking');
              try {
                await SelfServiceAPI.downloadInvoicePdf(booking);
              } catch (e) {
                openDownloadInvoiceErrorModal();
              }
            }}
          />
        )}
      </ActionBar>
      {isOpen && (
        <GuestAmendmentProvider>
          <GuestDetailsModal isOpen={isOpen} closeModal={closeModal} />
        </GuestAmendmentProvider>
      )}
    </>
  );
};

export default ManageBookingActions;
